function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = function (app, mod, group, chat_open) {
  var id = group.id;
  var last_msg = '<em>new chat</em>';
  var time = '';
  if (group.txs.length > 0) {
    var tx = group.txs[group.txs.length - 1];
    var regex3 = /<div class="file-name">[^>]*>/i;
    if (tx.msg.indexOf('<img') == 0) {
      last_msg = '<em>[image]</em>';
    } else if (regex3.test(tx.msg)) {
      last_msg = tx.msg.match(regex3)[0];
    } else {
      last_msg = app.browser.sanitize(tx.msg);
    }
    var regex = /<blockquote[^]*<\/blockquote>/i;
    last_msg = last_msg.replace(regex, '<em>RE:</em> ').replace('<br>', '');
    var regex2 = /<a[^>]+>/i;
    last_msg = last_msg.replace(regex2, '').replace('</a>', '');
    if (tx !== null && tx !== void 0 && tx.mentioned) {
      var _iterator = _createForOfIteratorHelper(tx.mentioned),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var m = _step.value;
          last_msg = last_msg.replace("data-id=\"".concat(m, "\""), '');
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
  var identicon_source = id;
  if (group.members.length == 2 && !(group !== null && group !== void 0 && group.member_ids)) {
    var _iterator2 = _createForOfIteratorHelper(group.members),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var mem = _step2.value;
        if (mem !== mod.publicKey) {
          identicon_source = mem;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  var notification = group !== null && group !== void 0 && group.notification ? ' new-notification' : '';
  group.notification = false;
  var imgsrc = app.keychain.returnIdenticon(identicon_source);
  var classes = 'saito-user ' + notification;
  if (group !== null && group !== void 0 && group.online) {
    classes += group.online;
  }
  if (chat_open) {
    classes += ' saito-chat-active';
  }

  // reduce flicker of browser mutation observer
  var display_name = group.name;
  if (app.wallet.isValidPublicKey(display_name)) {
    display_name = app.keychain.returnUsername(display_name);
  }
  var html = "\n  <div class=\"".concat(classes, "\" id=\"saito-user-").concat(id, "\" data-id=\"").concat(id, "\" data-disable=\"true\">\n    <div class=\"saito-identicon-box\">\n      <img class=\"saito-identicon\" src=\"").concat(imgsrc, "\" data-disable=\"true\"/>\n    </div>\n    <div class=\"saito-address saito-address-long\">\n    \t<div class=\"chat-group-name\">").concat(display_name, "</div>\n    \t").concat(group !== null && group !== void 0 && group.muted ? "<i class=\"fa-solid fa-volume-xmark\"></i>" : '', "\n    </div>\n    <div class=\"saito-userline\">").concat(last_msg, "</div>\n    <div class=\"saito-chat-notifications\">");
  if (group.mentioned) {
    html += "<div class=\"saito-notification-dot\">@</div>";
  }
  if (group.unread > 0) {
    html += "<div class=\"saito-notification-dot\">".concat(group.unread, "</div>");
  }
  html += "</div>\n    <div class=\"online-status-indicator\"><i class=\"fa-solid fa-bolt-lightning\"></i></div>\n  </div>";
  return html;
};